import React, { Component } from "react";
import { Modal, Form } from "antd";
import ImageView from "../../ui/ImageView";
import server from "../../../axios/server";
const FormItem = Form.Item;

class StockCheckViewForm extends Component {
  constructor(props) {
    super(props);

    this.state = { previewImage: "", previewVisible: false };
  }

  getImageUrl(img) {
    return (
      server.httpServerUrl +
      "/common/image?imagePath=" +
      encodeURIComponent(img)
    );
  }

  componentWillMount() {}

  previewImage(img, e) {
    console.log(img);
    this.setState({
      previewImage: this.getImageUrl(img),
      previewVisible: true,
    });
  }

  handlePreviewCancel = () => {
    this.setState({ previewVisible: false });
  };

  showImages(editData) {
    if (editData && editData.photos) {
      var imgs = editData.photos.split(";");
      var result = [];
      imgs.forEach((img) => {
        result.push(
          <img
            alt="pic"
            onClick={this.previewImage.bind(this, img)}
            width={200}
            key={img}
            src={this.getImageUrl(img)}
          />
        );
      });
      return result;
    }
  }

  render() {
    const { visible, onCancel, editData } = this.props;
    return (
      <Modal
        visible={visible}
        footer={null}
        onCancel={onCancel}
        title="盘点情况查看"
        maskClosable={false}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem label="车架号：">{editData.vin}</FormItem>
          <FormItem label="车辆名称">{editData.vehicleName}</FormItem>
          <FormItem label="车牌号：">{editData.plateNo}</FormItem>
          <FormItem label="商户：">{editData.memberName}</FormItem>
          <FormItem label="盘点人：">{editData.checkUName}</FormItem>
          <FormItem label="状态：">{editData.stateStr}</FormItem>
          {editData.state <= 5 ? (
            ""
          ) : (
            <FormItem label="说明：">{editData.memo || "未填写"}</FormItem>
          )}
          <FormItem label="照片">{this.showImages(editData)}</FormItem>
        </Form>
        <ImageView
          src={this.state.previewImage}
          visible={this.state.previewVisible}
          handleCancel={this.handlePreviewCancel.bind(this)}
        />
      </Modal>
    );
  }
}

const StockCheckView = Form.create()(StockCheckViewForm);

export default StockCheckView;
